import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <a class=", " href=\"", "work/", "\" ref=", ">\n                <canvas-transition .url=\"", "work/", "\" .useTransition=", " ref=", "\"></canvas-transition>\n                <h2 class=", " ref=", ">", "</h2>\n                <p class=", " ref=", ">", "</p>\n            </a>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import anime from 'animejs';
import store from 'lib/store';
import CanvasTransition from './canvas-transition';
import { ref } from 'lib/lit-ref';
import * as styles from './styles';
export default class HomeSlide extends Component {
  init() {
    this.options.autoDestroy = false;
  }

  render() {
    let viewCampaign = store.get('content').config.viewCampaign;
    let work = this.work;
    return html(_templateObject(), styles.wrapper, ENV.baseURL, work.slug, ref(this, 'link'), ENV.assetsURL, work.background, this.useTransition, ref(this, 'canvas'), styles.title, ref(this, 'title'), work.titleHome || work.title, styles.link, ref(this, 'label'), viewCampaign);
  }

  onRender() {
    this.classList.add(styles.slide);
    this.classList.add('u-hidden');
  }

  enterFirst() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise((resolve, reject) => {
      return this.animateInFirst(params, () => {
        this._afterEnter();

        resolve();
      });
    });
  }

  animateInFirst(params, complete) {
    let tl = anime.timeline({
      begin: () => {
        this.refs.title.classList.add('u-hidden');
        this.refs.label.classList.add('u-hidden');
        this.classList.remove('u-hidden');
      },
      complete
    });
    this.refs.canvas.enter();
    tl.add({
      targets: [this.refs.title, this.refs.label],
      opacity: [0, 1],
      translateY: [20, 0],
      duration: 1300,
      easing: 'easeOutQuint',
      delay: anime.stagger(80),
      begin: () => {
        this.refs.title.classList.remove('u-hidden');
        this.refs.label.classList.remove('u-hidden');
      }
    }, params.delay + 1000);
  }

  animateIn(params, complete) {
    anime.remove(this);
    anime({
      targets: [this.refs.title, this.refs.label],
      opacity: [0, 1],
      duration: 400,
      easing: 'linear',
      delay: params.delay + 200
    });
    anime({
      targets: this,
      opacity: [0, 1],
      duration: 800,
      easing: 'easeOutCubic',
      delay: params.delay,
      begin: () => {
        this.classList.remove('u-hidden');
      },
      complete
    });
  }

  animateOut(params, _complete) {
    anime.remove(this);
    anime({
      targets: this,
      opacity: 0,
      duration: 400,
      easing: 'easeOutQuart',
      complete: () => {
        this.classList.add('u-hidden');

        _complete();
      }
    });
  }

  onDestroy() {}

}
customElements.define('rv-slide', HomeSlide);